<template>
  <el-dialog
    :title="model.category_id == 1 ? '采购单入库' : '普通入库'"
    :visible.sync="visible"
    width="960px"
    @close="$emit('update:show', false)"
  >
    <el-form :model="model" :rules="rules" ref="form" label-width="100px" size="small">
      <el-form-item
        style="position: relative"
        label="采购单号"
        prop="purchase_order_id"
        v-if="model.category_id == 1"
      >
        <el-select
          size="small"
          class="fix-width"
          filterable
          placeholder="请选择"
          v-model="model.purchase_order_id"
          :disabled="model.category_id == 1"
        >
          <el-option
            v-for="item in purchase_orders"
            :key="item.id"
            :label="item.number"
            :value="parseInt(item.id)"
          ></el-option>
        </el-select>

        <!-- <div
          class="panel"
          style="position: absolute; top: 0; left: 300px; width: 400px; z-index:1"
          v-if="purchase_order"
        >
          <div class="header">
            <h2>采购清单</h2>
          </div>
          <ul class="item-list">
            <li class="flex-row-between" v-for="item in purchase_order.items">
              <span>{{ item.item.name }}</span>
              <span>x{{ item.count }}</span>
            </li>
          </ul>
        </div>-->
      </el-form-item>
      <el-form-item label="收货仓库" prop="stockroom_id">
        <el-select size="small" class="fix-width" placeholder="请选择" v-model="model.stockroom_id">
          <el-option
            v-for="item in stockrooms"
            :key="item.id"
            :label="item.name"
            :value="parseInt(item.id)"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="经办人">
        <el-select size="small" class="fix-width" placeholder="请选择" v-model="model.transactor_id">
          <el-option
            v-for="item in users"
            :key="item.id"
            :label="item.name"
            :value="parseInt(item.id)"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="入库时间" prop="stock_in_date">
        <el-date-picker
          v-model="model.stock_in_date"
          size="small"
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
        ></el-date-picker>
      </el-form-item>

      <el-form-item class="list" label="产品明细" prop="items">
        <el-table
          v-if="model.items && model.items.length > 0"
          :data="model.items"
          header-row-class-name="customer-mini-header"
        >
          <el-table-column label="对象" width="60px">
            <template slot-scope="scope">{{scope.row.category == 1 ? "零件" : "设备"}}</template>
          </el-table-column>
          <el-table-column align="center" prop="name" label="名称" min-width="150px"></el-table-column>
          <el-table-column align="center" prop="part_number" label="件号" width="150px"></el-table-column>
          <el-table-column align="center" prop="machine_type" label="机型" width="150px"></el-table-column>
          <el-table-column align="center" label="单价" width="100px">
            <template slot-scope="scope">
              <el-input-number
                :controls="false"
                style="width: 80px"
                size="mini"
                v-model="scope.row.price"
                :precision="2"
                :min="0"
              ></el-input-number>
            </template>
          </el-table-column>
          <el-table-column align="center" label="数量" width="120px">
            <template slot-scope="scope">
              <el-input-number
                v-model="scope.row.number"
                :disabled="model.category_id == 1"
                style="width: 100px"
                size="mini"
                type="number"
                :min="1"
                :max="1000"
              ></el-input-number>
            </template>
          </el-table-column>
          <el-table-column width="50" v-if="model.category_id != 1">
            <template slot-scope="scope">
              <el-button type="text" class="text-danger" @click="removeItem(scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-button
          size="small"
          icon="el-icon-plus"
          type="primary"
          @click="itemSelectorVisible = true"
          v-if="model.category_id != 1"
        >添加</el-button>
      </el-form-item>

      <el-form-item label="备注">
        <el-input
          v-model="model.remark"
          type="textarea"
          :autosize="{ minRows: 2, maxRows: 8}"
          class="fix-width"
          size="small"
          autocomplete="off"
        ></el-input>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button size="small" type="primary" @click="submitForm">确 定</el-button>
    </div>

    <item-device-selector
      :show.sync="itemSelectorVisible"
      :selection="model.items"
      :inner="true"
      :multiple="true"
      @selected="doneSelectedItems"
    ></item-device-selector>
  </el-dialog>
</template>

<script>
import ItemDeviceSelector from '@/components/item_selector'
import {
  createStockInBill,
  updateStockInBill,
  stockroomList,
  purchaseOrderList,
  purchaseOrderDetail,
  userList,
} from '@/service/getData'

export default {
  components: {
    ItemDeviceSelector,
  },
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
        this.purchase_order = null
      } else {
        if (this.model.category_id == 1 && !this.model.init_order) {
          this.getPurchaseOrders()
        }
      }
    },
    'model.purchase_order_id': 'getPurchaseOrderInfo',
  },
  created() {
    this.initData()
  },
  data() {
    return {
      visible: this.show,
      itemSelectorVisible: false,
      stockrooms: [],
      users: [],
      purchase_order: null,
      purchase_orders: [],
      rules: {
        purchase_order_id: [{ required: true, message: '请选择采购单号' }],
        stockroom_id: [{ required: true, message: '请选择收货仓库' }],
        stock_in_date: [{ required: true, message: '请选择入库时间' }],
        items: [
          {
            type: 'array',
            required: true,
            message: '请至少选择一个产品',
            trigger: 'change',
          },
        ],
      },
    }
  },
  methods: {
    async initData() {
      const pagination = { page: 0, size: 1000, resource_not_filter: true }

      let resStockroom = await stockroomList(pagination)
      let resUser = await userList(pagination)
      // let resPurchaseOrder = await purchaseOrderList({
      //   page: 0,
      //   size: 1000,
      //   status: 7
      // })

      this.stockrooms = resStockroom.data.list
      this.users = resUser.data.list
      // this.purchase_orders = resPurchaseOrder.data.list
    },

    async getPurchaseOrders() {
      let resPurchaseOrder = await purchaseOrderList({
        page: 0,
        size: 1000,
        status: 7,
        resource_not_filter: true,
      })
      this.purchase_orders = resPurchaseOrder.data.list
    },

    async getPurchaseOrderInfo() {
      if (this.model.purchase_order_id) {
        let res = await purchaseOrderDetail(this.model.purchase_order_id)
        if (res.code == 0) {
          this.purchase_order = res.data
          this.purchase_orders = [this.purchase_order]
        }
      }
    },
    removeItem(index) {
      this.model.items.splice(index, 1)
    },
    doneSelectedItems(items) {
      this.model.items = this.model.items.concat(items)
      this.model.items.map((v) => {
        this.$set(v, 'number', 1)
      })
      this.$refs.form.validateField('items')
    },
    formatData(obj) {
      const keys = ['transactor_id', 'purchase_order_id']
      for (let key in obj) {
        if (keys.indexOf(key) != -1 && obj[key] == '') {
          obj[key] = 0
        }
      }
      return obj
    },

    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          let data = this.formatData(this.model)
          if (this.purchase_order) {
            data.order_number = this.purchase_order.number
          }
          if (data.id > 0) {
            let res = await updateStockInBill(data)
            if (res.code == 0) {
              this.$emit('updated', res.data)
            }
          } else {
            let res = await createStockInBill(data)
            if (res.code == 0) {
              this.$emit('created', res.data)
            }
          }
          this.visible = false
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
  },
}
</script>
<style scoped>
.fix-width {
  width: 220px;
}
</style>>